import { Set } from 'immutable';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ViewModelService } from 'src/app/shared/view-model.service';
import { CardViewModel } from 'src/models/card-view-model';
import { NotificationRecipientViewModel } from 'src/models/notification-recipient-view-model';
import { selectViewModel } from 'src/models/view-model-helper';
import { selectErrorMessageByMessageId } from 'src/store/entityStores/message-status-update-selectors';
import {
  selectNotificationRecipientById,
  selectNotificationRecipientsByNotificationId,
} from 'src/store/entityStores/notification-recipient-selectors';
import {
  NotificationRecord,
  NotificationViewModelBase,
} from 'src/store/generated/notification-record.generated';
import { timeElapsed } from 'src/util/helpers/date-helper';
import { humanize } from '../util/text';
import { MessageStatusUpdateViewModel } from './message-status-update-view-model';

export class NotificationViewModel extends NotificationViewModelBase {
  public recipientIds$: Observable<Set<string>>;

  get hasRecipients$() {
    return this.recipientIds$.pipe(map((rIds) => rIds.count() > 0));
  }

  get timeElapsed() {
    return timeElapsed(this.dateCreated);
  }

  get statusString() {
    return humanize(this.status);
  }

  constructor(
    notification: NotificationRecord,
    public readonly card: CardViewModel | null,
    private readonly _model: ViewModelService,
  ) {
    super(notification);

    this.recipientIds$ = _model.store
      .select(selectNotificationRecipientsByNotificationId(notification.id))
      .pipe(map((recipients) => recipients.map((r) => r.id).toSet()));
  }

  public getRecipientById(recipientId: string | null) {
    return recipientId == null
      ? of(undefined)
      : selectViewModel(
          this._model.store,
          selectNotificationRecipientById(recipientId),
          (recipient) => new NotificationRecipientViewModel(recipient, this),
        );
  }

  public getErrorMessageByMessageId(messageId: string | null) {
    return messageId == null
      ? of(undefined)
      : selectViewModel(
          this._model.store,
          selectErrorMessageByMessageId(messageId),
          (message) => new MessageStatusUpdateViewModel(message),
        );
  }
}
